import { useMediaQuery } from 'usehooks-ts';

export const DEFAULT_MOBILE_MEDIA_QUERY = '(max-width: 640px)';

interface UseResponsiveViewportOptions {
  defaultValue?: boolean;
  initializeWithValue?: boolean;
}

export const useResponsiveViewport = (
  query = DEFAULT_MOBILE_MEDIA_QUERY,
  options: UseResponsiveViewportOptions = {},
) => {
  const {
    defaultValue = false,
    initializeWithValue = false,
  } = options;

  return useMediaQuery(query, {
    defaultValue,
    initializeWithValue,
  });
};
